import React from 'react'
// import {
//   Accordion,
//   AccordionItem,
//   AccordionItemHeading,
//   AccordionItemButton,
//   AccordionItemPanel,
// } from 'react-accessible-accordion'
import { Modal } from 'react-bootstrap'
// import DisplayImagepointsAndpeorid from './DisplayImagepointsAndpeorid'
import MoviePersonAutoSuggestions from '../CreateListmoviespersons/MoviePersonAutoSuggestions'
import PointsRadiobuttons from './PointsRadiobuttons'
import LoadingSpinner from './Loading'
import PointsOverRideAccordianComponent from './PointsOverRideAccordianComponent'

const PointsOverRideUi = ({
  isLoading,
  AutoSuggestionSelectedOption,
  setAutoSuggestionSelectedOption,
  openAccordionIndex,
  toggleAccordion,
  Topmovies,
  TopPersons,
  TopWebserises,
  trendingTopMovies,
  trendingTopPersons,
  trendingTopWebseries,
  handleSubmitAllForms,
  searchBarVisible,
  toggleSearchBar,
  searchMoviePerson,
  autoSuggestions,
  handleSelectAutoSuggestion,
  onRemove,
  selectedContentType,
  setTrendingTopMovies,
  setTrendingTopPersons,
  setTrendingTopWebseries,
}) => (
  <>
    <div>
      SearchPointsOverRide
      {isLoading && <LoadingSpinner />}
      <PointsRadiobuttons
        options={['week', 'month', 'year', 'currentdate', 'lifetime']}
        radioButtonsName={'AutoSuggestion'}
        setSelectedOption={setAutoSuggestionSelectedOption}
        selectedOption={AutoSuggestionSelectedOption}
      />
      <label>Trending</label>
      <PointsOverRideAccordianComponent
        onRemove={onRemove}
        selectedContentType={selectedContentType}
        setTrendingTopMovies={setTrendingTopMovies}
        setTrendingTopPersons={setTrendingTopPersons}
        setTrendingTopWebseries={setTrendingTopWebseries}
        openAccordionIndex={openAccordionIndex}
        toggleAccordion={toggleAccordion}
        Topmovies={Topmovies}
        TopPersons={TopPersons}
        TopWebserises={TopWebserises}
        trendingTopMovies={trendingTopMovies}
        trendingTopPersons={trendingTopPersons}
        trendingTopWebseries={trendingTopWebseries}
        AutoSuggestionSelectedOption={AutoSuggestionSelectedOption}
        toggleSearchBar={toggleSearchBar}
      />
      <div style={{ textAlign: 'center' }}>
        <button type='button' onClick={handleSubmitAllForms} className='btn btn-primary'>
          Submit
        </button>
      </div>
    </div>
    <Modal show={searchBarVisible} onHide={() => toggleSearchBar()}>
      <Modal.Header>Search...</Modal.Header>
      <Modal.Body>
        <input
          className='form-control'
          placeholder={'search'}
          onChange={event => searchMoviePerson(event.target.value)}
        />
        <MoviePersonAutoSuggestions
          autoSuggestions={autoSuggestions}
          searchBarVisible={searchBarVisible}
          handleSelectAutoSuggestion={handleSelectAutoSuggestion}
        />
      </Modal.Body>
    </Modal>
  </>
)

export default PointsOverRideUi
